import clsx from 'clsx';
import type React from 'react';

import { cn } from '@/shared/classnames';

export function Settings(props: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className="max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none"
      {...props}
    />
  );
}

export function SettingsSection(props: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      {...props}
    />
  );
}

export function SettingsSet(props: React.ComponentPropsWithoutRef<'dl'>) {
  return (
    <dl
      className="mt-6 divide-y divide-gray-100 border-t border-gray-200 text-sm/6"
      {...props}
    />
  );
}

export function Setting(props: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className="py-6 sm:flex"
      {...props}
    />
  );
}

type SettingNameProps = {
  valign?: 'top' | 'center';
} & React.ComponentPropsWithoutRef<'dt'>;

export function SettingName({ valign = 'top', ...props }: SettingNameProps) {
  return (
    <dt
      className={clsx(
        'flex font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6',
        valign === 'top' ? 'items-start' : 'items-center'
      )}
      {...props}
    />
  );
}

export function SettingContent({ className, ...props }: React.ComponentPropsWithoutRef<'dd'>) {
  return (
    <dd
      className={cn('mt-1 flex items-center justify-between gap-x-6 sm:mt-0 sm:flex-auto', className)}
      {...props}
    />
  );
}
